import React, { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { CheckboxListItem as Checkbox, Text } from '@adc/parallax-component-library';
import { useApiError } from 'Hooks';
import { CountryBottomSheetModal, FormContainer, RichText } from 'Components/utility';
import { SelectorInput } from 'Components/utility/SelectorInput';
import i18n from 'Utilities/i18n';
import { store } from 'Utilities/store';
import { updateConfig } from 'Services/config';
import { ContentContainer } from '../helpers';
const RegisterConfirmCountry = ({ formikForm, setLoading, countries, }) => {
    const { values, setFieldValue } = formikForm;
    const [isBottomSheetModalOpen, setIsBottomSheetModalOpen] = useState(false);
    const { showApiErrorModal } = useApiError();
    const onCancelBottomSheetModal = useCallback(() => {
        setIsBottomSheetModalOpen(false);
    }, []);
    const onSelectCountry = useCallback(async (selectedCountry) => {
        try {
            setIsBottomSheetModalOpen(false);
            setLoading(true);
            const { app, appVersion, deviceManufacturer, deviceModel, osType, osVersion } = store.getState().env;
            await updateConfig(true, selectedCountry, app, appVersion, deviceManufacturer, deviceModel, osType, osVersion);
            setFieldValue('country', selectedCountry);
            setLoading(false);
        }
        catch {
            showApiErrorModal();
            setLoading(false);
        }
    }, [setFieldValue, setLoading, showApiErrorModal]);
    const countryFromApp = useSelector((state) => state.env.country);
    const selectorValue = useMemo(() => {
        const country = values.country || countryFromApp;
        return country ? i18n.t(`Global.microcopy.countries.${country.toUpperCase()}`) : '';
    }, [countryFromApp, values.country]);
    return (React.createElement(ContentContainer, null,
        React.createElement(Text, null, i18n.t('ConfirmCountry.subtitle')),
        React.createElement(FormContainer, { hasHiddenUserInput: true },
            React.createElement(SelectorInput, { testID: "ConfirmCountry", label: i18n.t('ConfirmCountry.content.selectCountry.primaryText'), placeholder: i18n.t('ConfirmCountry.content.selectCountry.secondaryText'), "aria-label": i18n.t('ConfirmCountry.content.selectCountry.primaryText'), value: selectorValue, onClick: () => setIsBottomSheetModalOpen(true) }, () => {
                return (React.createElement(CountryBottomSheetModal, { title: i18n.t('ConfirmCountry.content.selectCountry.primaryText'), selectedCountry: values.country, isOpen: isBottomSheetModalOpen, onCancel: onCancelBottomSheetModal, onDone: onSelectCountry, countries: countries }));
            }),
            React.createElement(Checkbox, { checked: values.confirmCountryChecked, testID: "ConfirmCountry.checkBox", 
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                title: React.createElement(RichText, { text: i18n.t('ConfirmCountry.content.selectCountry.bodyText') }), disabled: !values.country, onPress: () => setFieldValue('confirmCountryChecked', !values.confirmCountryChecked) }))));
};
export { RegisterConfirmCountry };
